import { Component, OnInit } from '@angular/core';
import { TopMasterKeyService } from '../../../services/top-master-key-service';
import { Observable } from 'rxjs';
import { TopMasterKeyResult } from '../../../models/TopMasterKeyResult';

@Component({
    selector: 'lib-top-master-key',
    templateUrl: './top-master-key.component.html',
    styleUrls: ['./top-master-key.component.scss'],
    standalone: false
})
export class TopMasterKeyComponent implements OnInit {
  parity = 'EEOEOO';
  pins: string;
  keysObservable$: Observable<Array<TopMasterKeyResult>>;

  constructor(private topMasterKeyService: TopMasterKeyService) {}

  ngOnInit(): void {}

  onGenerate() {
    if (!this.parity) {
      return;
    }
    if (this.pins === 'six') {
      this.keysObservable$ = this.topMasterKeyService.getKeysForSixPin(this.parity);
    } else {
      this.keysObservable$ = this.topMasterKeyService.getKeysForFivePin(this.parity);
    }
  }
}
